// assets/origin-tracking.js
(function () {
  if (typeof window === "undefined" || typeof document === "undefined") return;

  const CONFIG = {
    storageKey: "ially_origem_final",
    debug: false,
    syncCooldownMs: 800,

    // Páginas: total (inclui origem + última)
    maxPaginas: 20,

    // Eventos de navegação (cliques com data-origem-nav)
    maxNavEventos: 32,

    // Line item property (origem padrão)
    enableLineItemProperty: true,
    itemPropKey: "_origem",

    // (novo) line item property do brinde via carrinho
    giftPropKey: "_brinde_carrinho",
    giftPropValue: "veio_por_brinde_no_carrinho",

    // Cart attributes (nomes no Shopify)
    attrPaginasJson: "paginas_rastreio",
    attrNavEventosJson: "navegacao_eventos",
    attrPaginaOrigem: "pagina_origem",
    attrPaginaUltima: "pagina_ultima",
    attrReferenciaOrigem: "referencia_origem",
    attrDataOrigem: "data_origem",

    // (novo) status do brinde no carrinho (cart attributes)
    attrBrindeCarrinho: "brinde_carrinho",
    attrBrindeCarrinhoAt: "brinde_carrinho_at",

    // (novo - recomendado) timestamps auxiliares p/ "não marcou nada"
    attrBrindeCarrinhoOfferedAt: "brinde_carrinho_offered_at",
    attrBrindeCarrinhoNoActionAt: "brinde_carrinho_no_action_at",

    // (novo) marcação de thank you no cart attributes (para teste/visibilidade)
    attrThankYouMarked: "thank_you_marked",
    attrThankYouAt: "thank_you_at",

    // (novo) TTL do rastreio (em horas). Recomendado: 72
    ttlHours: 72,
  };

  // Textos finais desejados
  const GIFT_STATUS = {
    APPROVED: "Brinde aprovado",
    DECLINED: "Brinde negado",
    NO_ACTION: "Não marcou nada no brinde",
    OFFERED: "Brinde oferecido", // interno (opcional), serve pra saber que viu
  };

  const OVERRIDE = window.__ORIGIN_TRACKING__ || { debug: true };
  const C = Object.assign({}, CONFIG, OVERRIDE);

  // Onde você marca no HTML
  const ATTR_ATC = "data-origem-atc";
  const ATTR_NAV = "data-origem-nav";

  // ✅ removido: console logs (mantém flag/debug sem efeitos colaterais)
  function log() {
    if (!C.debug) return;
  }

  function nowISO() {
    try {
      return new Date().toISOString();
    } catch (e) {
      return "";
    }
  }

  function nowMs() {
    try {
      return Date.now();
    } catch (_) {
      return 0;
    }
  }

  function isoToMs(s) {
    try {
      return s ? new Date(s).getTime() : 0;
    } catch (_) {
      return 0;
    }
  }

  function safeParse(v) {
    try {
      return JSON.parse(v);
    } catch (e) {
      return null;
    }
  }

  function isExpired(st) {
    try {
      const ttlH = Number(C.ttlHours) || 0;
      if (!ttlH) return false;

      const ttlMs = ttlH * 60 * 60 * 1000;
      const t = isoToMs(st.updated_at) || isoToMs(st.created_at) || 0;
      if (!t) return false;

      return nowMs() - t > ttlMs;
    } catch (_) {
      return false;
    }
  }

  function freshState() {
    return {
      // Base fixa
      pagina_origem: null,
      referencia_origem: null,
      data_origem: null,

      // Jornada de páginas
      paginas: [],

      // Eventos nav (from -> to)
      nav_eventos: [],
      nav_pendente: null, // { tag, from, ts }

      // ATC pendente (vira _origem no item)
      atc_pendente: null,

      // (opcional) origem do landing
      landing_src: null,
      __landing_marked: false,

      // (novo) brinde carrinho
      brinde_carrinho: null, // "Brinde negado" | "Brinde aprovado" | "Não marcou..." | "Brinde oferecido" | null
      brinde_carrinho_at: null,
      brinde_carrinho_offered_at: null,
      brinde_carrinho_no_action_at: null,

      // (novo) pendência para marcar line item property do brinde no PRÓXIMO /cart/add
      gift_cart_pending: false,
      gift_cart_pending_variant_id: null, // blindagem p/ não vazar

      // (novo) thank you (só p/ debug)
      thank_you_marked: false,
      thank_you_at: null,

      // (novo) timestamps para TTL
      created_at: null,
      updated_at: null,
    };
  }

  function normalizeGiftStatusValue(v) {
    const s = (v == null ? "" : String(v)).trim();
    if (!s) return null;

    // compat com versões antigas
    if (s === "declined") return GIFT_STATUS.DECLINED;
    if (s === "accepted") return GIFT_STATUS.APPROVED;
    if (s === "no_action" || s === "ignored") return GIFT_STATUS.NO_ACTION;
    if (s === "offered" || s === "pending") return GIFT_STATUS.OFFERED;

    // já no formato novo
    return s;
  }

  function readState() {
    const raw = localStorage.getItem(C.storageKey);
    const st = raw ? safeParse(raw) : null;

    // normaliza
    const next = st || freshState();

    // se expirou, reseta silenciosamente
    if (st && isExpired(next)) {
      try {
        localStorage.removeItem(C.storageKey);
      } catch (_) {}
      return freshState();
    }

    // garante campos novos caso venham de versões antigas
    if (next.created_at == null) next.created_at = null;
    if (next.updated_at == null) next.updated_at = null;

    if (next.thank_you_marked == null) next.thank_you_marked = false;
    if (next.thank_you_at == null) next.thank_you_at = null;

    if (next.brinde_carrinho == null) next.brinde_carrinho = null;
    if (next.brinde_carrinho_at == null) next.brinde_carrinho_at = null;
    if (next.brinde_carrinho_offered_at == null) next.brinde_carrinho_offered_at = null;
    if (next.brinde_carrinho_no_action_at == null) next.brinde_carrinho_no_action_at = null;

    if (next.gift_cart_pending == null) next.gift_cart_pending = false;
    if (next.gift_cart_pending_variant_id == null) next.gift_cart_pending_variant_id = null;

    // garante arrays
    if (!Array.isArray(next.paginas)) next.paginas = [];
    if (!Array.isArray(next.nav_eventos)) next.nav_eventos = [];

    // normaliza valor do status
    next.brinde_carrinho = normalizeGiftStatusValue(next.brinde_carrinho);

    return next;
  }

  function writeState(st) {
    try {
      const iso = nowISO();
      if (!st.created_at) st.created_at = iso;
      st.updated_at = iso;
      localStorage.setItem(C.storageKey, JSON.stringify(st));
    } catch (e) {}
  }

  function compactRef(ref) {
    try {
      return ref ? new URL(ref, location.origin).pathname : "";
    } catch (e) {
      return "";
    }
  }

  // ============
  // ORIGEM BASE (fixa)
  // ============
  function ensureOrigemBase(st, refOverride) {
    const ref = typeof refOverride === "string" ? refOverride : (document.referrer || "").trim();
    if (!st.pagina_origem) st.pagina_origem = location.pathname || "/";
    if (!st.referencia_origem) st.referencia_origem = ref ? compactRef(ref) : "";
    if (!st.data_origem) st.data_origem = nowISO();
  }

  // ============
  // THANK YOU (debug)
  // ============
  function isThankYouLikely() {
    try {
      const p = String(location.pathname || "").toLowerCase();
      if (p.includes("thank-you") || p.includes("thank_you")) return true;
      const t = String(document.title || "").toLowerCase();
      if (t.includes("thank") || t.includes("obrigad")) return true;
      return false;
    } catch (_) {
      return false;
    }
  }

  function markThankYou() {
    try {
      const st = readState();
      if (st.thank_you_marked) return false;
      st.thank_you_marked = true;
      st.thank_you_at = nowISO();
      writeState(st);
      try { scheduleSync({ immediate: true }); } catch (_) {}
      try { scheduleUnloadFlush(); } catch (_) {}
      log("THANK YOU marcado", { thank_you_at: st.thank_you_at });
      return true;
    } catch (_) {
      return false;
    }
  }

  // ============
  // LANDING SRC (opcional)
  // ============
  function marcarOrigemDeEntradaSeVazio() {
    const st = readState();
    if (st.__landing_marked) return;

    const ref = (document.referrer || "").trim();
    let src = "direct";

    try {
      if (ref) {
        const u = new URL(ref, location.origin);
        if (u.origin === location.origin) src = "internal:" + (u.pathname || "/");
        else src = "external:" + (u.hostname || "external");
      }
    } catch (_) {
      src = "direct";
    }

    st.landing_src = src;
    ensureOrigemBase(st, ref);

    st.__landing_marked = true;
    writeState(st);
    scheduleSync({ immediate: true });
  }

  // ============
  // PÁGINAS (10 total: origem fixa + últimas)
  // ============
  function trackPaginaAtual() {
    const st = readState();
    ensureOrigemBase(st);

    const to = location.pathname || "/";
    if (!Array.isArray(st.paginas)) st.paginas = [];

    if (st.paginas.length === 0) {
      st.paginas.push(st.pagina_origem || to);
    }

    const last = st.paginas[st.paginas.length - 1];

    if (last !== to) {
      if (st.paginas.length < (Number(C.maxPaginas) || 20)) {
        st.paginas.push(to);
      } else {
        if (st.paginas.length >= 2) st.paginas.splice(1, 1);
        st.paginas.push(to);
      }
    }

    fecharNavPendente(st, to);

    writeState(st);
    scheduleSync();
  }

  // ============
  // NAV EVENTOS
  // ============
  function marcarNav(tag) {
    if (!tag) return;

    const st = readState();
    ensureOrigemBase(st);

    st.nav_pendente = {
      tag,
      from: location.pathname || "/",
      ts: nowISO(),
    };

    writeState(st);
    scheduleSync({ immediate: true });
    scheduleUnloadFlush();
  }

  function fecharNavPendente(st, toPath) {
    if (!st.nav_pendente) return;

    const pend = st.nav_pendente;
    const from = pend.from || "";
    const to = toPath || (location.pathname || "/");

    if (from === to) return;

    if (!Array.isArray(st.nav_eventos)) st.nav_eventos = [];

    st.nav_eventos.push({
      tag: pend.tag || "",
      from,
      to,
      ts: pend.ts || nowISO(),
    });

    const maxEv = Number(C.maxNavEventos) || 32;
    if (st.nav_eventos.length > maxEv) {
      st.nav_eventos.splice(0, st.nav_eventos.length - maxEv);
    }

    st.nav_pendente = null;
  }

  // ============
  // CART ATTRIBUTES
  // ============
  function buildCartAttributes() {
    const st = readState();

    const paginas = Array.isArray(st.paginas) ? st.paginas.slice() : [];
    const paginaUltima = paginas.length ? paginas[paginas.length - 1] : (location.pathname || "/");
    const navEventos = Array.isArray(st.nav_eventos) ? st.nav_eventos.slice() : [];

    const base = {
      [C.attrPaginaOrigem]: st.pagina_origem || "",
      [C.attrPaginaUltima]: paginaUltima || "",
      [C.attrReferenciaOrigem]: st.referencia_origem || "",
      [C.attrDataOrigem]: st.data_origem || "",

      [C.attrPaginasJson]: JSON.stringify(paginas),
      [C.attrNavEventosJson]: JSON.stringify(navEventos),
    };

    base[C.attrThankYouMarked] = st.thank_you_marked ? "true" : "";
    base[C.attrThankYouAt] = st.thank_you_at || "";

    // status brinde carrinho (textos finais)
    base[C.attrBrindeCarrinho] = st.brinde_carrinho || "";
    base[C.attrBrindeCarrinhoAt] = st.brinde_carrinho_at || "";
    base[C.attrBrindeCarrinhoOfferedAt] = st.brinde_carrinho_offered_at || "";
    base[C.attrBrindeCarrinhoNoActionAt] = st.brinde_carrinho_no_action_at || "";

    return base;
  }

  // ============
  // SYNC /cart/update.js
  // ============
  let syncing = false;
  let lastHash = "";
  let lastSyncAt = 0;
  let syncTimer = null;

  function scheduleSync(opts) {
    opts = opts || {};
    const now = Date.now();

    if (opts.immediate) {
      const can = now - lastSyncAt >= 80;
      if (can) {
        clearTimeout(syncTimer);
        syncTimer = null;
        syncCartAttrs();
        return;
      }
    }

    if (syncTimer) return;
    syncTimer = setTimeout(() => {
      syncTimer = null;
      syncCartAttrs();
    }, Math.max(0, Number(C.syncCooldownMs) || 0));
  }

  function syncCartAttrs() {
    const attrs = buildCartAttributes();
    const hash = JSON.stringify(attrs);

    const now = Date.now();
    if (syncing) return;
    if (hash === lastHash) return;

    if (now - lastSyncAt < (Number(C.syncCooldownMs) || 0)) {
      clearTimeout(syncTimer);
      syncTimer = setTimeout(() => {
        syncTimer = null;
        syncCartAttrs();
      }, (Number(C.syncCooldownMs) || 0) - (now - lastSyncAt));
      return;
    }

    syncing = true;
    lastSyncAt = now;

    fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ attributes: attrs }),
      credentials: "same-origin",
      keepalive: true,
    })
      .then(() => {
        lastHash = hash;
        syncing = false;
        log("Cart attributes sincronizados", attrs);
      })
      .catch(() => {
        syncing = false;
      });
  }

  // ============
  // FLUSH NO UNLOAD (beacon)
  // ============
  let unloadArmed = false;

  function attrsToUrlEncoded(attrs) {
    const p = new URLSearchParams();
    Object.keys(attrs || {}).forEach((k) => {
      p.set(`attributes[${k}]`, String(attrs[k] == null ? "" : attrs[k]));
    });
    return p.toString();
  }

  function beaconSync() {
    try {
      const attrs = buildCartAttributes();
      const body = attrsToUrlEncoded(attrs);

      if (navigator && typeof navigator.sendBeacon === "function") {
        const blob = new Blob([body], { type: "application/x-www-form-urlencoded; charset=UTF-8" });
        navigator.sendBeacon("/cart/update.js", blob);
      } else {
        fetch("/cart/update.js", {
          method: "POST",
          headers: { "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8" },
          body,
          credentials: "same-origin",
          keepalive: true,
        }).catch(() => {});
      }
    } catch (_) {}
  }

  function scheduleUnloadFlush() {
    if (unloadArmed) return;
    unloadArmed = true;

    window.addEventListener("pagehide", () => beaconSync(), { capture: true });
    document.addEventListener(
      "visibilitychange",
      () => {
        if (document.visibilityState === "hidden") beaconSync();
      },
      { capture: true }
    );
  }

  // ============
  // BRINDE CARRINHO (API para cart-gifts.js)
  // ============
  function markGiftCartDeclined() {
    try {
      const st = readState();
      ensureOrigemBase(st);

      st.brinde_carrinho = GIFT_STATUS.DECLINED; // ✅ "Brinde negado"
      st.brinde_carrinho_at = nowISO();
      st.gift_cart_pending = false;
      st.gift_cart_pending_variant_id = null;

      writeState(st);
      scheduleSync({ immediate: true });
      scheduleUnloadFlush();

      log("BRINDE_CARRINHO marcado como NEGADO", { at: st.brinde_carrinho_at });
      return true;
    } catch (_) {
      return false;
    }
  }

  // chama com variantId do brinde
  function markGiftCartAcceptedPending(variantId) {
    try {
      const st = readState();
      ensureOrigemBase(st);

      st.brinde_carrinho = GIFT_STATUS.APPROVED; // ✅ "Brinde aprovado"
      st.brinde_carrinho_at = nowISO();
      st.gift_cart_pending = true;
      st.gift_cart_pending_variant_id = variantId != null ? String(variantId) : null;

      writeState(st);
      scheduleSync({ immediate: true });
      scheduleUnloadFlush();

      log("BRINDE_CARRINHO marcado como APROVADO + pending", {
        at: st.brinde_carrinho_at,
        variantId: st.gift_cart_pending_variant_id,
      });
      return true;
    } catch (_) {
      return false;
    }
  }

  // marca quando o brinde foi OFERECIDO (serve pra detectar "não marcou nada")
  function markGiftCartOffered() {
    try {
      const st = readState();
      ensureOrigemBase(st);

      // se já decidiu, não mexe
      if (st.brinde_carrinho === GIFT_STATUS.APPROVED || st.brinde_carrinho === GIFT_STATUS.DECLINED) return false;

      st.brinde_carrinho = GIFT_STATUS.OFFERED;
      if (!st.brinde_carrinho_offered_at) st.brinde_carrinho_offered_at = nowISO();

      writeState(st);
      scheduleSync({ immediate: true });
      scheduleUnloadFlush();

      log("BRINDE_CARRINHO marcado como OFERECIDO", { at: st.brinde_carrinho_offered_at });
      return true;
    } catch (_) {
      return false;
    }
  }

  // marca quando ele NÃO clicou em nada (apenas se tinha sido oferecido)
  function markGiftCartNoAction() {
    try {
      const st = readState();
      ensureOrigemBase(st);

      // só marca no_action se ainda não há decisão
      if (st.brinde_carrinho === GIFT_STATUS.APPROVED || st.brinde_carrinho === GIFT_STATUS.DECLINED) return false;

      // recomendado: só faz sentido se foi oferecido alguma vez
      if (!st.brinde_carrinho_offered_at) return false;

      st.brinde_carrinho = GIFT_STATUS.NO_ACTION; // ✅ "Não marcou nada no brinde"
      st.brinde_carrinho_no_action_at = nowISO();

      writeState(st);
      scheduleSync({ immediate: true });
      scheduleUnloadFlush();

      log("BRINDE_CARRINHO marcado como NAO_MARCOU_NADA", { at: st.brinde_carrinho_no_action_at });
      return true;
    } catch (_) {
      return false;
    }
  }

  function consumeGiftCartPending() {
    try {
      const st = readState();
      if (!st.gift_cart_pending) return false;
      st.gift_cart_pending = false;
      st.gift_cart_pending_variant_id = null;
      writeState(st);
      return true;
    } catch (_) {
      return false;
    }
  }

  // ============
  // LINE ITEM PROPERTIES (_origem + _brinde_carrinho)
  // ctx: { variantId }
  // ============
  function obterPropsDoItem(ctx) {
    const st = readState();
    const props = {};
    ctx = ctx || {};

    // _origem (ATC pendente)
    if (C.enableLineItemProperty) {
      const tag = st.atc_pendente || "";
      if (tag) props[C.itemPropKey] = tag;
    }

    // _brinde_carrinho (somente se pending e bater variant)
    if (st.gift_cart_pending) {
      const pendingVid = st.gift_cart_pending_variant_id ? String(st.gift_cart_pending_variant_id) : null;
      const currentVid = ctx.variantId != null ? String(ctx.variantId) : null;

      if (!pendingVid || (currentVid && pendingVid === currentVid)) {
        props[C.giftPropKey] = C.giftPropValue || "veio_por_brinde_no_carrinho";
      }
    }

    return Object.keys(props).length ? props : null;
  }

  function limparAtcPendenteSeExistir() {
    try {
      const st = readState();
      if (st.atc_pendente) {
        st.atc_pendente = null;
        writeState(st);
      }
    } catch (_) {}
  }

  function marcarAtc(tag) {
    if (!tag) return;

    const st = readState();
    ensureOrigemBase(st);

    st.atc_pendente = tag;
    writeState(st);

    scheduleSync({ immediate: true });
    scheduleUnloadFlush();
  }

  // ============
  // HELPERS: extrair variantId do /cart/add
  // ============
  function extractVariantIdFromBody(body, contentType) {
    try {
      if (!body) return null;

      // FormData
      if (typeof FormData !== "undefined" && body instanceof FormData) {
        const v = body.get("id");
        if (v != null) return String(v);

        const v0 = body.get("items[0][id]");
        if (v0 != null) return String(v0);

        return null;
      }

      // string: JSON ou urlencoded
      if (typeof body === "string") {
        const trimmed = body.trim();
        const ct = String(contentType || "").toLowerCase();

        // JSON
        if (ct.includes("application/json") || trimmed.startsWith("{")) {
          const obj = safeParse(trimmed) || {};
          if (Array.isArray(obj.items) && obj.items[0] && obj.items[0].id != null) return String(obj.items[0].id);
          if (obj.id != null) return String(obj.id);
          return null;
        }

        // urlencoded
        const p = new URLSearchParams(body);
        const v = p.get("id");
        if (v != null) return String(v);
        const v0 = p.get("items[0][id]");
        if (v0 != null) return String(v0);
        return null;
      }

      // object (provável JSON)
      if (typeof body === "object") {
        if (Array.isArray(body.items) && body.items[0] && body.items[0].id != null) return String(body.items[0].id);
        if (body.id != null) return String(body.id);
      }

      return null;
    } catch (_) {
      return null;
    }
  }

  // ============
  // submit form /cart/add  (injeta TODAS as properties)
  // ============
  if (C.enableLineItemProperty) {
    document.addEventListener(
      "submit",
      function (e) {
        const form = e.target;
        if (!form || !form.action || !form.action.includes("/cart/add")) return;

        let variantId = null;
        try {
          const idInput = form.querySelector('[name="id"]');
          if (idInput && idInput.value) variantId = String(idInput.value);
        } catch (_) {}

        const props = obterPropsDoItem({ variantId });
        if (!props) return;

        Object.keys(props).forEach((k) => {
          const name = `properties[${k}]`;
          let input = form.querySelector(`input[name="${name}"]`);
          if (!input) {
            input = document.createElement("input");
            input.type = "hidden";
            input.name = name;
            form.appendChild(input);
          }
          input.value = String(props[k]);
        });
      },
      { capture: true }
    );

    // ============
    // AJAX /cart/add(.js) (injeta TODAS as properties)
    // ============
    (function interceptFetch() {
      if (!window.fetch) return;
      const originalFetch = window.fetch;

      function setMultiPropertyInFormData(fd, key, value) {
        const idxSet = new Set();
        for (const [k] of fd.entries()) {
          const m = String(k).match(/^items\[(\d+)\]\[id\]$/);
          if (m) idxSet.add(Number(m[1]));
        }
        if (idxSet.size === 0) return false;
        idxSet.forEach((i) => fd.set(`items[${i}][properties][${key}]`, value));
        return true;
      }

      function setMultiPropertyInUrlEncoded(params, key, value) {
        let found = false;
        for (const [k] of params.entries()) {
          const m = String(k).match(/^items\[(\d+)\]\[id\]$/);
          if (m) {
            found = true;
            const i = Number(m[1]);
            params.set(`items[${i}][properties][${key}]`, value);
          }
        }
        return found;
      }

      window.fetch = function (input, init) {
        const url = typeof input === "string" ? input : input?.url || "";
        init = init || {};
        const method = String(init.method || "GET").toUpperCase();

        if (method !== "POST" || (!url.includes("/cart/add.js") && !url.includes("/cart/add"))) {
          return originalFetch.call(this, input, init);
        }

        try {
          marcarOrigemDeEntradaSeVazio();
          trackPaginaAtual();
          scheduleSync({ immediate: true });
          scheduleUnloadFlush();
        } catch (_) {}

        const headers = new Headers(init.headers || {});
        const ct = (headers.get("Content-Type") || headers.get("content-type") || "").toLowerCase();
        const body = init.body;

        const variantId = extractVariantIdFromBody(body, ct);

        const props = obterPropsDoItem({ variantId });
        if (!props) {
          return originalFetch.call(this, input, init);
        }

        try {
          // FormData
          if (typeof FormData !== "undefined" && body instanceof FormData) {
            Object.keys(props).forEach((k) => {
              const v = String(props[k]);
              const okMulti = setMultiPropertyInFormData(body, k, v);
              if (!okMulti) body.set(`properties[${k}]`, v);
            });
            init.body = body;
          }
          // string
          else if (typeof body === "string") {
            const trimmed = body.trim();

            if (ct.includes("application/json") || trimmed.startsWith("{")) {
              const obj = safeParse(trimmed) || {};

              if (Array.isArray(obj.items)) {
                obj.items = obj.items.map((it) => {
                  const next = Object.assign({}, it);
                  next.properties = Object.assign({}, next.properties || {}, props);
                  return next;
                });
              } else {
                obj.properties = Object.assign({}, obj.properties || {}, props);
              }

              init.body = JSON.stringify(obj);
              headers.set("Content-Type", "application/json");
              init.headers = headers;
            } else {
              const p = new URLSearchParams(body);

              Object.keys(props).forEach((k) => {
                const v = String(props[k]);
                const okMulti = setMultiPropertyInUrlEncoded(p, k, v);
                if (!okMulti) p.set(`properties[${k}]`, v);
              });

              init.body = p.toString();
              if (!ct) headers.set("Content-Type", "application/x-www-form-urlencoded; charset=UTF-8");
              init.headers = headers;
            }
          }
          // object
          else if (body && typeof body === "object") {
            const obj = Object.assign({}, body);

            if (Array.isArray(obj.items)) {
              obj.items = obj.items.map((it) => {
                const next = Object.assign({}, it);
                next.properties = Object.assign({}, next.properties || {}, props);
                return next;
              });
            } else {
              obj.properties = Object.assign({}, obj.properties || {}, props);
            }

            init.body = JSON.stringify(obj);
            headers.set("Content-Type", "application/json");
            init.headers = headers;
          }
        } catch (_) {}

        return originalFetch.call(this, input, init).then((res) => {
          if (res && res.ok) {
            limparAtcPendenteSeExistir();

            // consome pending do brinde SOMENTE se este add bate com o variant pendente
            try {
              const st = readState();
              if (st.gift_cart_pending) {
                const pendingVid = st.gift_cart_pending_variant_id ? String(st.gift_cart_pending_variant_id) : null;
                if (!pendingVid || (variantId && String(variantId) === pendingVid)) {
                  consumeGiftCartPending();
                }
              }
            } catch (_) {}
          }
          return res;
        });
      };
    })();
  }

  // ============
  // CAPTURA CLIQUES NAV/ATC
  // ============
  document.addEventListener(
    "click",
    function (e) {
      const navEl = e.target.closest(`[${ATTR_NAV}]`);
      if (navEl) {
        marcarNav(navEl.getAttribute(ATTR_NAV));
        return;
      }

      const atcEl = e.target.closest(`[${ATTR_ATC}]`);
      if (atcEl) {
        marcarAtc(atcEl.getAttribute(ATTR_ATC));
      }
    },
    { capture: true }
  );

  // ============
  // TRACK PAGEVIEW (load + SPA)
  // ============
  try {
    // eslint-disable-next-line no-undef
    handleThankYouFlagIfAny && handleThankYouFlagIfAny();

    marcarOrigemDeEntradaSeVazio();
    trackPaginaAtual();
    scheduleUnloadFlush();
  } catch (_) {}

  (function patchHistory() {
    try {
      const _pushState = history.pushState;
      const _replaceState = history.replaceState;

      function onRouteChange() {
        try {
          trackPaginaAtual();
        } catch (_) {}
      }

      history.pushState = function () {
        const r = _pushState.apply(this, arguments);
        onRouteChange();
        return r;
      };

      history.replaceState = function () {
        const r = _replaceState.apply(this, arguments);
        onRouteChange();
        return r;
      };

      window.addEventListener("popstate", onRouteChange);
    } catch (_) {}
  })();

  // ============
  // API pública
  // ============
  window.IALLY_ORIGIN = {
    trackPage: trackPaginaAtual,
    markNav: marcarNav,
    markAtc: marcarAtc,
    markThankYou: markThankYou,
    isThankYou: isThankYouLikely,

    // integração com cart-gifts.js
    markGiftCartDeclined: markGiftCartDeclined,
    markGiftCartAcceptedPending: markGiftCartAcceptedPending,
    markGiftCartOffered: markGiftCartOffered,
    markGiftCartNoAction: markGiftCartNoAction,

    get: () => readState(),
    cartAttrs: () => buildCartAttributes(),
    reset: () => {
      try {
        localStorage.removeItem(C.storageKey);
      } catch (_) {}
    },
    flush: () => {
      try {
        syncCartAttrs();
        beaconSync();
      } catch (_) {}
    },
  };
})();
